//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tips1: {
      type: String,
      default: ''
    },
    tips2: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancle: function cancle() {
      this.$emit('cancle');
    },
    commit: function commit() {
      this.$emit('commit', {
        bool: true
      });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }
};